import { Auth, API } from "aws-amplify";
import { IContentType, IContent, IFlight, IDynamicQuery } from "@vmosolutions/oc-interfaces";

export const getContentTypes = async (): Promise<IContentType[]> => {
  try {
    const userSession = await Auth.currentSession();
    const token = userSession.getIdToken().getJwtToken();

    const contentTypes = await API.get("skytrains", "/contentTypes", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
    });

    return contentTypes;
  } catch (error) {
    console.error(error);
    return [];
  }
};

interface ICreateContentResponse {
  content: IContent;
  uploadURL: string;
}
export const createContent = async (data: Partial<IContent>, fileData: ArrayBuffer | null): Promise<any | null> => {
  try {
    const userSession = await Auth.currentSession();
    const token = userSession.getIdToken().getJwtToken();

    const contentResponse: ICreateContentResponse = await API.post("skytrains", "/content", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: data,
    });

    if (fileData && contentResponse.uploadURL) {
      const uploadResponse = await fetch(contentResponse.uploadURL, {
        method: "PUT",
        body: fileData,
      });
      console.log("uploadResponse", uploadResponse);
    }
    return contentResponse;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const listContent = async (): Promise<IContent[]> => {
  try {
    const userSession = await Auth.currentSession();
    const token = userSession.getIdToken().getJwtToken();

    const contentListResponse: IContent[] = await API.get("skytrains", "/content", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
    });
    return contentListResponse;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getAssociatedFlights = async (data: string[]): Promise<IFlight[]> => {
  try {
    const userSession = await Auth.currentSession();
    const token = userSession.getIdToken().getJwtToken();

    const response = await API.post("skytrains", "/flights/getFlights", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: data,
    });

    return response;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const updateContent = async (
  contentId: string,
  data: Partial<IContent>,
  fileData: ArrayBuffer | null
): Promise<any | null> => {
  try {
    const userSession = await Auth.currentSession();
    const token = userSession.getIdToken().getJwtToken();

    const contentResponse: ICreateContentResponse = await API.put("skytrains", `/content/${contentId}`, {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: data,
    });

    //TODO: Handle updating the attachemnt in S3
    // if (fileData && contentResponse.uploadURL) {
    //   const uploadResponse = await fetch(contentResponse.uploadURL, {
    //     method: "PUT",
    //     body: fileData,
    //   });
    //   console.log("UPLOADED");
    //   console.log(uploadResponse);
    // }
    return contentResponse;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// SEARCH CONTENT
export const searchContent = async (payload: IDynamicQuery): Promise<IContent | null> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const response = await API.post("skytrains", "/searchContent", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: payload,
    });
    return response;
  } catch (error) {
    //@ts-ignore
    return error?.response;
  }
};

/**
 * get the thumbnail image for a content item based on its id
 * @param contentId - the object id of the content
 * @returns a binary thumbnail image
 */
export const getThumbnail = async (contentId: string): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const response = await API.get("skytrains", `/content/thumbnail/${contentId}`, {
      headers: {
        Accept: "image/png",
        Authorization: token,
      },
      responseType: "blob",
    });
    return response;
  } catch (error) {
    //@ts-ignore
    return error?.response;
  }
};
